import React from 'react';
import Helmet from 'react-helmet';

import InOutHistoryUserUnregisteredStore from '../services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredStore';
import InOutHistoryUserUnregisteredContext from '../services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredContext';

import InfinityScrollLoad from '../components/InfinityScrollLoad';
// @TODO: 2019/12月リリース時点では検索機能には対応しない
import { SearchForm } from '../components/searchmenus/InOutHistoryUserUnregisteredSearch';
import { OperationHeader } from '../components/header/InOutHistoryUserUnregisteredHeader';
import { TableLayout } from '../components/tables/InOutHistoryUserUnregisteredTable';
import Information from '../components/modals/common/Information';
import ReflectFailedByAlreadyRegisteredErrorDialog from '../components/modals/ReflectFailedByAlreadyRegisteredErrorDialog';

import { messageUtility } from '../utilities/messageUtility';

/**
 * 不明な入退場データ画面
 */
export class InOutHistoryUserUnregistered extends React.Component {
  // 画面表示
  render() {
    return (
      <InOutHistoryUserUnregisteredStore>
        <InOutHistoryUserUnregisteredContext.Consumer>
          {({
            state,
            infiniteScrollLoad,
            closeNotExistFieldIdDialog,
            closeReflectFailedByAlreadyRegisteredErrorDialog,
          }) => (
            <React.Fragment>
              <div id='main' className='main'>
                <Helmet title={data.title} />
                <div className='main__header'>
                  <h1>{data.title}</h1>
                </div>

                <div id='infinityscroll-target' className='main__body'>
                  <div className='gate-schedulelist'>
                    <OperationHeader />
                    <SearchForm propertyName={'searchForm'} />

                    <TableLayout />
                    <InfinityScrollLoad
                      targetId='infinityscroll-target'
                      total={state.searchForm.total}
                      reset={state.canLoadMore}
                      callback={notify => {
                        infiniteScrollLoad(notify);
                      }}
                    />
                  </div>
                </div>
              </div>
              <Information
                message={messageUtility.getMessage('E-002-001-006')}
                buttonText={messageUtility.getMessage('I-000-008')}
                visible={state.isShowNotExistFieldIdDialog}
                onClose={() => closeNotExistFieldIdDialog()}
              />
              <ReflectFailedByAlreadyRegisteredErrorDialog
                reqLogsLength={
                  state.reflectFailedByAlreadyRegisteredError.reqLogsLength
                }
                errLogs={state.reflectFailedByAlreadyRegisteredError.errLogs}
                visible={state.reflectFailedByAlreadyRegisteredError.showDialog}
                onClose={() =>
                  closeReflectFailedByAlreadyRegisteredErrorDialog()
                }
              />
            </React.Fragment>
          )}
        </InOutHistoryUserUnregisteredContext.Consumer>
      </InOutHistoryUserUnregisteredStore>
    );
  }
}

// 定数
const data = {
  title: '不明な入退場データ',
};



// WEBPACK FOOTER //
// ./src/pages/InOutHistoryUserUnregistered.jsx